<script>
export default {
  scenes: [
    // TODO ファイル名をIDとヒモづける
    { id: 1, sceneName: 'フラワーシャワー', avatar: '/static/icon/ico1.png' },
    { id: 2, sceneName: 'アフターセレモニー', avatar: '/static/icon/ico2.png' },
    { id: 3, sceneName: '披露宴入場', avatar: '/static/icon/ico3.png' },
    { id: 4, sceneName: '乾杯', avatar: '/static/icon/ico4.png' },
    { id: 5, sceneName: 'ケーキ入刀', avatar: '/static/icon/ico5.png' },
    { id: 6, sceneName: '新婦中座', avatar: '/static/icon/ico6.png' },
    { id: 7, sceneName: '新郎中座', avatar: '/static/icon/ico7.png' },
    { id: 8, sceneName: 'お色直し入場', avatar: '/static/icon/ico8.png' },
    { id: 15, sceneName: '各卓イベント', avatar: '/static/icon/ico15.png' },
    { id: 9, sceneName: 'メイン演出', avatar: '/static/icon/ico9.png' },
    { id: 10, sceneName: '手紙朗読', avatar: '/static/icon/ico10.png' },
    { id: 11, sceneName: '花束贈呈', avatar: '/static/icon/ico11.png' },
    { id: 12, sceneName: '退場', avatar: '/static/icon/ico12.png' },
    { id: 14, sceneName: 'その他', avatar: '/static/icon/ico13.png' }
  ],
  notSearchOptionId: [14, 15],
  findAll () {
    return this.scenes
  },
  findAllSearchOption () {
    let result = []
    for (let i = 0; i < this.scenes.length; i++) {
      if (this.notSearchOptionId.indexOf(this.scenes[i].id) < 0) {
        result.push(this.scenes[i])
      }
    }
    return result
  },
  /**
   * sceneIdから各アイコンのパスを取得する
   **/
  findIconPathBySceneId (sceneId) {
    let obj = this.getObjectBySceneId(sceneId)
    return obj.avatar
  },
  findSceneNameBySceneId (sceneId) {
    let obj = this.getObjectBySceneId(sceneId)
    return obj.sceneName
  },
  getObjectBySceneId (sceneId) {
    let result = {}
    for (let i = 0; i < this.scenes.length; i++) {
      if (this.scenes[i].id === parseInt(sceneId)) {
        result = this.scenes[i]
      }
    }
    return result
  }
}
</script>



// WEBPACK FOOTER //
// src/components/services/SceneService.vue